<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Select from "@/components/c-select";
import Input from "@/components/c-input";
import Button from "@/components/c-button";
import moment from 'moment'
import { dailyReportService } from "../../../../services/reportservice/dailyreportservice.js";


/* eslint-disable no-console */
export default {
  page: {
    title: "Customer Follow Up Report",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { 
    Layout, 
    PageHeader, 
    Button,
    Select, 
    Input
  },
  data() {
    return {
      title: "Customer Follow Up Report",
      data: [],
      date: {},
      seller: {},
      user: JSON.parse(localStorage.getItem('user')),

      dataDate: '',
      dataSellerId: 0,
    };
  },
  mounted() {
    this.loadingData();
    
  },
  methods: {
    loadingData: function() {
      dailyReportService.getCustomerFollowUp()
        .then(response => {
          this.data = response.data.result;
          this.date = response.data.date;
          this.dataDate = response.data.date;
          this.seller = response.data.seller;
        });
    },
    submitSearch: function() {
      let data = '?seller_id='+this.dataSellerId+'&date='+this.dataDate;
      dailyReportService.getCustomerFollowUp(data)
        .then(response => {
          this.data = response.data.result;
          this.date = response.data.date;
          this.seller = response.data.seller;
      });
    },
    dateFormat: function(value, format='DD/MM/YYYY'){
      return moment(String(value)).format(format);
    },
    discountPrice(price, discount, dis_type) {
        let total = 0;
        if(dis_type==1){
          total = price * discount / 100;
        }else{
          total = discount
        }
        return total
    },
    formatCurrency(value) {
      if(value == 0 ){
        return 0;
      }
      let sign = '$';
      let decimal = ''; //'.00';
      return this.$options.filters.numFormat(value, `${sign}0,0${decimal}`);

      // return value;
    },
    print() {
      window.print();
    },

    getSellerName() {

      // if(Object.keys(this.seller).length === 0) {
      //   return this.user.name;
      // } else {

      //   let seller = this.seller.find(item => item.id == this.dataSellerId);
      //   if(seller) {
      //     return seller.label.substring(0, seller.label.indexOf('('));
      //   } else {
      //     return this.user.name;
      //   }
      // }

      return "";
    }
  },
  computed: {
    totalPrice() {
      return this.data.reduce(function (sum, item) {
        return sum + (item.interest + item.paid_loan)
      }, 0)
    },
    
    
  }
};

</script>

<template>
  <Layout>
    <PageHeader @click="print()" :add="{icon: 'bx bx-printer', title: 'general.print'}" :title="$t('report.daily.customer-followup')" />
      <div class="row search-area">
        <div class="col-sm-2">
          <Select
            :id="'id'"
            :text="'label'"
            :editable="true"
            :list="{data: this.seller}"
            v-model="dataSellerId"
          /> 
        </div>
         <div class="col-sm-2">
            <Input 
              :type="'date'"
              :id="'record_date'"
              v-model="dataDate"
            /> 
          </div>
        <div class="col-sm-2">
          <Button v-bind:icon="'bx bx-search'"
            @click="submitSearch()" 
            v-bind:buttonType="'button'"
            v-bind:variant="'primary'"
            v-bind:title="$t('general.search')" 
          />
        </div>
      </div>
      <div id="print-area">
        <div class="col dblack box-a4l">
          <table width="100%" class="content-general bottom">
            <tr>
              <td width="5%"><p>&nbsp;</p></td>
              <td width="50%"><p>&nbsp;</p></td>
            </tr>
            <tr>
              <td><img src="@/assets/images/h-logo.svg" alt width="80" /></td>
              <td>
                <p class="khb h4"><b>ក្រុមហ៊ុនលំនៅឋាន<span class="g-color"> អេចស៊ី </span>ឯ.ក</b></p>
                <p class="enb h5"><b>LOMNOV THAN <span class="g-color">HC</span> CO., LTD</b></p>
                <p class="khs h8">អាសយដ្ឋានដីឡូតិ៍លេខៈ ៧៤២ ផ្លូវលេខៈ ១៩៥២ ភូមិបាយ៉ាប សង្កាត់ភ្នំពេញថ្មី ខណ្ឌសែនសុខ រាជធានីភ្នំពេញ</p>
                <p class="khs h8">ទូរស័ព្ទលេខៈ 092 926 688 | 086 626 689 Email: sales@h-residence.net</p>
              </td>
            </tr>
            
          </table>
          <hr/>
          <h3 class="text-center"><p class="khb"><u>{{$t('report.daily.customer-followup')+' '+$t('report.daily.date') + dateFormat(this.date)}}</u></p></h3>

          <table class="content-general h8 project-sumary-table report-table" width="100%">
           
              <tr class="thead">
                <th class="khs">{{$t('general.number')}}</th>
                <th class="khs">{{$t('report.daily.phone')}}</th>
                <th class="khs">{{$t('report.daily.source')}}</th>
                <th class="khs">{{$t('report.daily.customer-name')}}</th>
                <th class="khs">{{$t('report.daily.date')}}</th>
                <th class="khs">{{$t('report.daily.staff-name')}}</th>
                <th class="khs">{{$t('report.daily.payment-request')}}</th>
                <th class="khs">{{$t('report.daily.interestd')}}%</th>
                <th class="khs">{{$t('report.daily.description')}}</th>
              </tr>
            
            <tbody>
              <tr v-for="(list, index) in data" :key="index" >
                 <td class="khs" style="width: 35px;">{{index + 1}}</td>
                 <td class="khs" style="width: 90px;">{{list.phone_no_1}}</td>
                 <td class="khs" style="width: 100px;">{{list.source}}</td>
                 <td class="khs" style="width: 100px;">{{list.name}}</td>
                 <td class="khs" style="width: 80px;">{{dateFormat(list.created_at, 'DD/MM/YYYY h:mm A')}}</td>
                 <td class="khs" style="width: 80px;">{{list.seller_name}}</td>
                 <td class="khs">{{list.notation}}</td>
                 <td class="khs">{{list.interested}}%</td>
                 <td class="khs"  style="text-algin: left;">{{list.description}}</td>
              </tr>
            </tbody>
        
          </table>
        
          <div class="row mt-3">
            <div class="col">
              <center>
                <br>
                <br>
                <p>ត្រួតពិនិត្យដោយ<br>ប្រធានគ្រប់គ្រងទូទៅ</p>
                <br><br>
                <p class="khm h6"></p>
              </center>
            </div>
            <div class="col">
              <center>
                <br>
                <br>
                 <p>អនុម័តដោយ<br>ប្រធានគ្រប់គ្រងផ្នែកលក់</p>
                <br><br>
                <p class="khm h6" ></p>
              </center>
            </div>
            <div class="col-4">
              <center>
                <p>ធ្វើនៅភ្នំពេញ ថ្ងៃខែឆ្នាំ {{dateFormat(this.date)}}</p>
                <p>រៀបរៀងដោយ<br>ផ្នែកលក់</p>
                <br><br>
                <p class="khm h6">{{this.user.name}}</p>
              </center>
            </div>
          </div>
        </div>  
      </div>
    <!-- end row -->
  </Layout>
</template>